import { IPopupNotification, NotificationKey } from './state';
import * as constants from './constants';
import * as actions from './actions';

export const popupNotificationEnqueued = (
  notification: IPopupNotification
): actions.IPopupNotificationEnqueued => {
  const key = notification.options && notification.options.key;

  return {
    type: constants.POPUP_NOTIFICATION_ENQUEUED,
    notification,
    key: key || new Date().getTime() + Math.random(),
  };
};

export const popupNotificationClosed = (
  key: NotificationKey
): actions.IPopupNotificationClosed => ({
  type: constants.POPUP_NOTIFICATION_CLOSED,
  key,
  dismissAll: !key,
});

export const popupNotificationRemoved = (
  key: NotificationKey
): actions.IPopupNotificationRemoved => ({
  type: constants.POPUP_NOTIFICATION_REMOVED,
  key,
});

export const actionTriggers = {
  popupNotificationEnqueued,
  popupNotificationClosed,
  popupNotificationRemoved,
};
